import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faDownload } from "@fortawesome/free-solid-svg-icons";

export default function ExportDropdown({
  canExportContactInfo,
  disabled,
  isExportingContactInfo,
  onExport,
  onExportContactInfo,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const closeDropdown = () => setIsOpen(false);

  const handleExport = () => {
    closeDropdown();
    onExport();
  };

  const handleExportContactInfo = async () => {
    closeDropdown();

    try {
      await onExportContactInfo();
    } catch (error) {
      console.error("Error exporting contact info:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);

  if (!canExportContactInfo) {
    return (
      <button
        className="bg-gray-200 px-3 py-2 rounded-lg text-sm cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2"
        onClick={onExport}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faDownload} />
        Export
      </button>
    );
  }

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        className="bg-gray-200 px-3 py-2 rounded-lg text-sm cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed inline-flex items-center gap-2"
        onClick={() => setIsOpen((prev) => !prev)}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faDownload} />
        {isExportingContactInfo ? "Exporting..." : "Export"}
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-1 min-w-60 bg-white border rounded-md shadow-lg z-20 overflow-hidden text-left">
          <button
            className="w-full px-4 py-3 text-sm hover:bg-gray-100 disabled:opacity-60 disabled:cursor-not-allowed text-left"
            onClick={handleExport}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faDownload} className="pr-2" /> Export
          </button>
          <button
            className="w-full px-4 py-3 text-sm hover:bg-gray-100 border-t disabled:opacity-60 disabled:cursor-not-allowed text-left inline-flex items-center gap-2"
            onClick={handleExportContactInfo}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faDownload} className="pr-2" />
            Export with contact info
          </button>
        </div>
      )}
    </div>
  );
}
